import gql from "graphql-tag";

const FILE_UPLOAD_MUTATION = gql`mutation Upload($file: Upload!, $formId: String!, $email: String!) {
  uploadFile(file: $file, formId: $formId, email: $email) {
    etag,
    lastModified,
    contentMD5,
    clientRequestId
    requestId
    version
    date
    isServerEncrypted
    encryptionKeySha256
    encryptionScope
    errorCode
  }
}`;

export default FILE_UPLOAD_MUTATION;